import ReceiveIcon from './ReceiveIcon'

export default ReceiveIcon
